const words = ["Pizzas à emporter", "Plats variés", "Depuis 2004", "Morangis", "Click & Collect", "Location de salle"];

const Row = ({ hidden }) => (
  <div className="marquee-row flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display italic text-4xl sm:text-6xl lg:text-7xl text-[#F7F4EB] px-6 sm:px-10 whitespace-nowrap">{w}</span>
        <svg viewBox="0 0 24 24" className="w-5 h-5 sm:w-7 sm:h-7 text-[#C85A32]" aria-hidden="true">
          <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative border-y border-[#D4A359]/20 py-8 sm:py-10 overflow-hidden bg-[#0E2A1B]" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
